import * as React from 'react'

import { useRef } from 'react'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

import { Popover } from '@pareto-engineering/design-system'

import './styles.scss'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'point'

/**
 * This is the component description.
 */
const Point = ({
  id,
  className: userClassName,
  style,
  top,
  left,
  location,
}) => {
  const ref = useRef()

  return (
    <div
      id={id}
      className={[
        baseClassName,
        componentClassName,
        userClassName,
      ]
        .filter((e) => e)
        .join(' ')}
      style={{
        ...style,
        top,
        left,
      }}
      ref={ref}
    >
      <Popover
        className="s-3"
        color="background-far"
        parentRef={ref}
      >
        {location}
      </Popover>
    </div>
  )
}

Point.propTypes = {
  /**
     * The HTML id for this element
     */
  id:PropTypes.string,

  /**
     * The HTML class names for this element
     */
  className:PropTypes.string,

  /**
     * The React-written, css properties for this element.
     */
  style:PropTypes.objectOf(PropTypes.string),

  /**
     * The top position of the point
     */
  top:PropTypes.string,

  /**
 * The left position of the point
 */
  left:PropTypes.bool,

  /**
 * The location of the point
 */
  location:PropTypes.string,
}

Point.defaultProps = {
  //
}

export default Point
